namespace SP.Data {
    export class Packaging {

        private static packagingInfos: SP.PackagingInfo[] = null;

        static async getPackagingInfos(useCache = true) {
            if (useCache && this.packagingInfos != null) return this.packagingInfos;
            var response = await SP.get<any>("/api/v1/info/packagingInfos/");
            if (response.status == 200) this.packagingInfos = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.packagingInfos;
        }

    }
}